<div class="lum-credit-memo-details-table">
  <div class="table-wrapper">
    <table class="lum-table lum-table--classic striped">
      <thead>
        <tr>
          <th><b>Invoice #</b></th>
          <th><b>SKU</b></th>
          <th class="w-70"><b>Applied Amount</b></th>
          <th><b>Date/Time</b></th>
          <th><b>User</b></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let paymentLog of creditMemoPaymentLogs">
          <td>
            <a
              href="javascript:;"
              target="_blank"
              [routerLink]="['/sales/view/invoices']"
              [queryParams]="{ invoiceId: paymentLog?.poId }"
              >{{ paymentLog?.poId }}</a
            >
          </td>
          <td>
            <ng-container *ngIf="paymentLog?.clientPurchaseOrder">
              <div class="invoice-sku-tags__wrapper">
                <div
                  *ngFor="
                    let item of paymentLog?.clientPurchaseOrder?.line_items;
                    trackBy: trackById
                  "
                  class="block"
                >
                  <mat-chip
                    class="
                      lum-chip lum-chip--label lum-chip--x-small border-transparent font-bold text-cloud-900 bg-cloud-300 mx-1
                    "
                    >[{{ item.sku }}] {{ item.product_name }}</mat-chip
                  >
                </div>
              </div>
            </ng-container>
          </td>
          <td>{{ paymentLog?.paymentAmount | currency }}</td>
          <td>{{ paymentLog?.createdAt | date: 'MMM d, y, h:mm a' }}</td>
          <td>
            {{ paymentLog?.createdByUser?.firstname }}
            {{ paymentLog?.createdByUser?.lastname }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
